<div class="flex flex-row justify-center items-center">
  <div>
    @switch (notification) {
      @case (notificationValue.InvitationDataInvalid) {
        <pin-notification type="alert">
          The invitation data does not match our invitation records.
        </pin-notification>
      }

      @case (notificationValue.InvitationExpired) {
        <div class="flex flex-row justify-center public-container">
          @if (!isLoading) {
            <div class="flex flex-col gap-10">
            <div class="flex flex-row gap-4">
              <div>
                <mat-icon class="md-37 primary-color">
                  cancel
                </mat-icon>
              </div>
              <div class="dcp-h2">This link is no longer valid.</div>
            </div>

            <pin-button buttonStyle="filled" buttonId="login" buttonType="button" redirectUrl="/login">LOG IN</pin-button>
          </div>
          }
        </div>
      }

      @case (notificationValue.AgentAccountAccessNotAllowed) {
      <pin-notification type="alert">
        Access to shared accounts has been removed by the Depositor's Institution.
      </pin-notification>
      }
    }
  </div>
</div>

@if (notification !== undefined && notification !== notificationValue.InvitationExpired && notification !== notificationValue.AgentAccountAccessNotAllowed) {
  <pin-agent-registration-page></pin-agent-registration-page>
}

@if (isLoading) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
